import { type useInfiniteListResponse } from './infinite-list-context-factory'

export * from './infinite-list'
export { infiniteListContextFactory } from './infinite-list-context-factory'
export * from './mundi-infinite-list'

export type InfiniteListHook = () => useInfiniteListResponse<any, any>
